import { Database, Megaphone, Truck } from "lucide-react"

import { Badge } from "@/components/ui/badge"
import { useTranslations } from "next-intl"


export function AgentIntegrationBadges({
  crmConnected,
  deliveryConnected,
  metaAdsConnected = false,
}: {
  crmConnected: boolean
  deliveryConnected: boolean
  metaAdsConnected?: boolean
}) {
  const tUi = useTranslations("AgentTools.AgentsSharedAgentIntegrationBadges")

  if (!crmConnected && !deliveryConnected && !metaAdsConnected) return null

  return (
    <div className="flex flex-wrap items-center justify-end gap-1">
      {crmConnected ? (
        <Badge
          variant="outline"
          className="border-blue-200 bg-blue-50 text-[10px] text-blue-700"
        >
          <Database aria-hidden="true" className="mr-1 h-3 w-3" />
          <span><span key={"CRM"}>{"CRM"}</span></span>
        </Badge>
      ) : null}
      {deliveryConnected ? (
        <Badge
          variant="outline"
          className="border-violet-200 bg-violet-50 text-[10px] text-violet-700"
        >
          <Truck aria-hidden="true" className="mr-1 h-3 w-3" />
          <span><span key={tUi("delivery")}>{tUi("delivery")}</span></span>
        </Badge>
      ) : null}
      {metaAdsConnected ? (
        <Badge
          variant="outline"
          className="border-sky-200 bg-sky-50 text-[10px] text-sky-700"
        >
          <Megaphone aria-hidden="true" className="mr-1 h-3 w-3" />
          <span><span key={"Meta Ads"}>{"Meta Ads"}</span></span>
        </Badge>
      ) : null}
    </div>
  )
}
